module.exports = __webpack_public_path__ + "static/media/cv.a0834c13.pdf";